import api from './api';

export interface MySubscription {
  plan: string;
  status: string;
  price_monthly: number;
  payment_status: string;
  last_payment_date: string | null;
  next_payment_date: string | null;
  payment_reported_at: string | null;
  // Cuando termina la prueba (o la suscripcion, si se cancelo)
  end_date: string | null;
  // Si este mes corresponde la revision trimestral de precio
  is_adjustment_month?: boolean;
  // Datos de cobro (los carga el superadmin)
  payment_alias: string | null;
  cbu: string | null;
  cvu: string | null;
  bank_holder: string | null;
  whatsapp_number: string | null;
}

export const subscriptionService = {
  getMySubscription: async (): Promise<MySubscription> => {
    const response = await api.get('/subscription/me');
    return response.data;
  },

  reportPayment: async (): Promise<MySubscription> => {
    const response = await api.post('/subscription/me/report-payment');
    return response.data;
  },
};
